import { isAuthErrorAtom } from '@data/auth';
import { ReloadRequiredDialog } from '@components/common/molecules';
import { useAtomValue } from 'jotai';

const AuthErrorDialog: React.FC = () => {
  const isAuthError = useAtomValue(isAuthErrorAtom);

  return (
    <ReloadRequiredDialog
      isOpen={isAuthError}
      title={'dialog.auth_error.title'}
      message={'dialog.auth_error.message'}
    />
  );
};

export default AuthErrorDialog;
